import handleClick from '../../../../utils/handleClick';
import computeClassName from '../../../../utils/computeClassName';
import { KEYS } from '../../../../l18n/constants';
import { useL18nContext } from '../../ContextProvider/L18n';
import CCLogo from '../../../libs/CiscoCore/Logo';
import NavigationLinksGroup1 from './NavigationLinksGroup1';
import NavigationLinksGroup2 from './NavigationLinksGroup2';
import MobileMenuToggle from './MobileMenu/Toggle';
import LogInLabel from '../UtilityBar/LogInLabel';
import UserInitials from './UserInitials';
import UserMenu from '../UserMenu';
import LanguageMenu from '../LanguageMenu';
//import CCIconGlobe20x20 from '../../../libs/CiscoCore/Icon/Globe/20x20';
import LanguageLabel from "../UtilityBar/LanguageLabel";


const constants = Object.freeze({
  CLASSNAME_BASE: 'bg-cc-primary text-cc-primary-contrast flex flex-row items-center justify-between sm:justify-start h-cc-21.25 relative'
});

const propsDefaults = Object.freeze(
  {
    isUserLoggedIn: false,
    userId: '',
    userInitials: '',
    isUserMenuOpened: false,
    toggleUserMenuFn: null,
    toggleOffUserMenuFn: null,
    isMobileMenuOpened : false,
    toggleMobileMenuFn: null,
    isLanguageMenuOpened: false,
    toggleLanguageMenuFn: null,
    toggleOffLanguageMenuFn: null
  }
);
export default function NavigationBar(
  {
    isLoggedInUser = propsDefaults.isUserLoggedIn,
    userId = propsDefaults.userId,
    userInitials = propsDefaults.userInitials,
    isUserMenuOpened = propsDefaults.isUserMenuOpened,
    toggleUserMenuFn = propsDefaults.toggleUserMenuFn,
    toggleOffUserMenuFn = propsDefaults.toggleOffUserMenuFn,
    isMobileMenuOpened = propsDefaults.isMobileMenuOpened,
    toggleMobileMenuFn = propsDefaults.toggleMobileMenuFn,
    isLanguageMenuOpened = propsDefaults.isLanguageMenuOpened,
    toggleLanguageMenuFn = propsDefaults.toggleLanguageMenuFn,
    toggleOffLanguageMenuFn = propsDefaults.toggleOffLanguageMenuFn,
    className = ''
  }) {

  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { getTranslationFor } = useL18nContext();
  const translatedChooseLanguageSelectionText = getTranslationFor(KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION);
  const buttonUserMenuToggleClickFn = handleClick(toggleUserMenuFn);
  const buttonLanguageMenuToggleClickFn = handleClick(toggleLanguageMenuFn);

  return (
    <div className={computedClassName}>
      <a className="ml-6 sm:ml-20" title="Cisco.com worldwide" href="https://www.cisco.com/"><CCLogo className="w-cc-23.75 max-h-full"/></a>
      <div className="hidden sm:ml-8 sm:mr-20 sm:flex-grow sm:flex sm:flex-row sm:items-center sm:justify-between">
        <NavigationLinksGroup1 className=""/>
        <NavigationLinksGroup2 className=""/>
      </div>
      <div className="sm:hidden mr-6 inline-flex flex-row items-center">
        {
          isLoggedInUser ?
            <button
              className="appearance-none inline-flex item-center"
              onClick={buttonUserMenuToggleClickFn}><UserInitials userInitials={userInitials}/></button> :
            <button
              className="appearance-none inline-flex item-center p-2 px-1 hover:underline hover:underline-thin hover:underline-lower"
              onClick={buttonUserMenuToggleClickFn}><LogInLabel/></button>
        }
        <button className="appearance-none inline-flex item-center p-2 ml-2 hover:underline hover:underline-thin hover:underline-lower"
                title={translatedChooseLanguageSelectionText}
                onClick={buttonLanguageMenuToggleClickFn}><LanguageLabel/></button>
        <MobileMenuToggle className="ml-3 xs:ml-6" isToggleOn={isMobileMenuOpened} toggleFn={toggleMobileMenuFn}/>
      </div>
      {
        isUserMenuOpened &&
        <UserMenu className="sm:hidden absolute z-10 top-full left-0"
                  isUserLoggedIn={isLoggedInUser}
                  userId={userId}
                  toggleOffUserMenuFn={toggleOffUserMenuFn}/>
      }
      {
        isLanguageMenuOpened &&
        <LanguageMenu className="sm:hidden absolute z-10 top-full left-0"
                      toggleOffLanguageMenuFn={toggleOffLanguageMenuFn}/>
      }
    </div>
  );
}
